"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekCanvas = exports.useSetWeekCanvasState = exports.useWeekCanvasState = exports.weekCanvasState = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var WeekViewKonva_1 = require("./WeekViewKonva");
var react_konva_1 = require("react-konva");
var hooks_1 = require("../../hooks");
var luxon_1 = require("luxon");
var clsx_1 = __importDefault(require("clsx"));
var WeekViewDnD_1 = require("./WeekViewDnD");
var ScrollBar_1 = require("./ScrollBar");
var recoil_1 = require("recoil");
exports.weekCanvasState = (0, recoil_1.atom)({
    key: "weekCanvasState",
    default: {
        anchorDate: luxon_1.DateTime.utc(),
        initialDate: luxon_1.DateTime.utc(),
        lastAdjustedDate: luxon_1.DateTime.utc(),
        scrollCursorDate: luxon_1.DateTime.utc(),
    },
});
var useWeekCanvasState = function () { return (0, recoil_1.useRecoilValue)(exports.weekCanvasState); };
exports.useWeekCanvasState = useWeekCanvasState;
var useSetWeekCanvasState = function () { return (0, recoil_1.useSetRecoilState)(exports.weekCanvasState); };
exports.useSetWeekCanvasState = useSetWeekCanvasState;
var SCROLL_TIMEOUT = 1500;
var FLOATING_HEADING_STYLES = "text-lochivar-default py-2 px-3 text-2xl absolute top-0 left-0 ml-2 my-1 bg-opacity-75 transition-opacity ease-out delay-300 duration-1000 bg-white rounded-full z-20 pointer-events-none";
var SCROLL_BAR_WIDTH = 16;
var WeekCanvas = function (_a) {
    var _b, _c;
    var className = _a.className, _d = _a.weeksVisible, weeksVisible = _d === void 0 ? 6 : _d, _e = _a.minViewportHeight, minViewportHeight = _e === void 0 ? 900 : _e, children = _a.children, weekNumberForWeek = _a.weekNumberForWeek, showMonthHeadings = _a.showMonthHeadings, props = __rest(_a, ["className", "weeksVisible", "minViewportHeight", "children", "weekNumberForWeek", "showMonthHeadings"]);
    var _f = (0, recoil_1.useRecoilValue)(exports.weekCanvasState), lastAdjustedDate = _f.lastAdjustedDate, initialDate = _f.initialDate, anchorDate = _f.anchorDate;
    var _g = (0, hooks_1.useScrollableCanvas)(), scroll = _g.scroll, setScroll = _g.setScroll, scrolling = _g.scrolling, setScrolling = _g.setScrolling, htmlProps = _g.htmlProps, stageProps = _g.stageProps, layerProps = _g.layerProps;
    var _h = (0, react_1.useState)(52), maxScrollableWeeks = _h[0], setMaxScrollableWeeks = _h[1];
    var _j = (0, react_1.useState)(0), lastIndex = _j[0], setLastIndex = _j[1];
    var konvaWrapper = (0, react_1.useRef)(null);
    var stage = (0, react_1.useRef)(null);
    var size = (0, hooks_1.useResizeObserver)({ element: konvaWrapper }).size;
    var weekHeight = Math.max(size.height, minViewportHeight) / weeksVisible;
    var index = scroll ? Math.floor(-scroll / weekHeight) : 0;
    var effectiveDate = initialDate;
    var setWeekCanvasState = (0, exports.useSetWeekCanvasState)();
    (0, react_1.useEffect)(function () {
        if (lastAdjustedDate !== anchorDate) {
            var targetDate_1 = (anchorDate !== null && anchorDate !== void 0 ? anchorDate : luxon_1.DateTime.utc())
                .startOf("week")
                .minus({ days: 1 });
            var originDate = initialDate.startOf("week").minus({ days: 1 });
            var weeks = Math.round(targetDate_1.diff(originDate, "weeks").weeks);
            setWeekCanvasState(function (state) { return (__assign(__assign({}, state), { anchorDate: targetDate_1, lastAdjustedDate: targetDate_1 })); });
            setScroll(-weeks * weekHeight);
            setScrolling(true);
        }
    }, [
        anchorDate,
        initialDate,
        lastAdjustedDate,
        setScroll,
        setScrolling,
        setWeekCanvasState,
        weekHeight,
    ]);
    var scrollTimeout = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (scrollTimeout.current) {
            clearTimeout(scrollTimeout.current);
        }
        scrollTimeout.current = setTimeout(function () {
            setScrolling(false);
        }, SCROLL_TIMEOUT);
    }, [scroll, scrollTimeout, setScrolling]);
    (0, react_1.useEffect)(function () {
        if (index !== lastIndex) {
            setLastIndex(index);
            setWeekCanvasState(function (state) { return (__assign(__assign({}, state), { scrollCursorDate: effectiveDate
                    .startOf("week")
                    .plus({ weeks: index })
                    .minus({ days: 1 }) })); });
            if (Math.abs(index) > maxScrollableWeeks / 2 - 5) {
                setMaxScrollableWeeks(maxScrollableWeeks + 10);
            }
        }
    }, [
        lastIndex,
        setLastIndex,
        index,
        setMaxScrollableWeeks,
        maxScrollableWeeks,
        setWeekCanvasState,
        effectiveDate,
    ]);
    var renderWeeks = function (renderWeek) {
        return Array(weeksVisible + 1)
            .fill(0)
            .map(function (_, i) {
            var weekIndex = index + i;
            var weekStart = effectiveDate
                .startOf("week")
                .plus({ weeks: weekIndex + (weeksVisible < 3 ? 1 : 0) })
                .minus({ days: 1 })
                .startOf("day")
                .toUTC();
            var weekTop = scroll + weekHeight * weekIndex;
            return renderWeek({
                isoDate: weekStart.toISODate(),
                date: weekStart,
                top: weekTop,
                height: weekHeight,
            });
        });
    };
    var contentHeight = weekHeight * maxScrollableWeeks;
    var handleScroll = (0, react_1.useCallback)(function (y) {
        setScroll(y);
    }, [setScroll]);
    var handleScrollClick = function (e) {
        e.preventDefault();
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)("inset-0 absolute", className), ref: konvaWrapper }, htmlProps, { children: [(0, jsx_runtime_1.jsx)(react_konva_1.Stage, __assign({ height: size.height, width: size.width, ref: stage }, stageProps, { children: (0, jsx_runtime_1.jsx)(react_konva_1.Layer, __assign({}, layerProps, { children: renderWeeks(function (_a) {
                            var isoDate = _a.isoDate, date = _a.date, top = _a.top;
                            return ((0, jsx_runtime_1.jsx)(WeekViewKonva_1.WeekViewKonva, __assign({}, props, { startDate: isoDate, x: 0, y: top, height: weekHeight, width: size.width, month: date.month, number: weekNumberForWeek === null || weekNumberForWeek === void 0 ? void 0 : weekNumberForWeek(date), ignoreOutOfRange: true }), isoDate));
                        }) }), void 0) }), void 0), renderWeeks(function (_a) {
                    var isoDate = _a.isoDate, top = _a.top, date = _a.date, rest = __rest(_a, ["isoDate", "top", "date"]);
                    var endDate = date.plus({ days: 1 }).endOf("week");
                    var newMonth = showMonthHeadings && date.month !== endDate.month;
                    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "absolute w-full left-0 top-0", style: {
                            transform: "translate3d(0, " + top + "px, 0)",
                            height: weekHeight,
                            pointerEvents: "none",
                        } }, { children: [newMonth ? ((0, jsx_runtime_1.jsxs)("h1", __assign({ className: (0, clsx_1.default)(FLOATING_HEADING_STYLES, !scrolling && "opacity-0") }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "font-bold" }, { children: endDate.monthLong }), void 0), " ", endDate.year] }), void 0)) : null, (0, jsx_runtime_1.jsx)(WeekViewDnD_1.WeekViewDnD, __assign({}, props, { startDate: isoDate }), void 0), children === null || children === void 0 ? void 0 : children(__assign({ isoDate: isoDate, top: top, date: date, newMonth: newMonth }, rest))] }), "htmlContents" + isoDate));
                }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "absolute inset-y-0 right-0 cursor-pointer z-20", onClick: handleScrollClick }, { children: (0, jsx_runtime_1.jsx)(react_konva_1.Stage, __assign({ height: size.height, width: SCROLL_BAR_WIDTH, ref: stage }, { children: (0, jsx_runtime_1.jsx)(react_konva_1.Layer, { children: (0, jsx_runtime_1.jsx)(ScrollBar_1.ScrollBar, { x: 0, y: 0, width: SCROLL_BAR_WIDTH, height: size.height, scroll: scroll, onScroll: handleScroll, contentHeight: contentHeight, offset: (_c = (_b = stage.current) === null || _b === void 0 ? void 0 : _b.getClientRect().y) !== null && _c !== void 0 ? _c : 0 }, void 0) }, void 0) }), void 0) }), void 0)] }), void 0) }, void 0));
};
exports.WeekCanvas = WeekCanvas;
